module.exports = __webpack_public_path__ + "img/pay.54ca4422.png";